<script setup lang="ts">
/**
 * Confirmation modal with standard header + body slot + Cancel/Action footer.
 * Defaults to a destructive "Delete" action but can be customized for any
 * confirm-style modal (duplicate, archive, etc.).
 */

withDefaults(
  defineProps<{
    open: boolean
    /** Modal header text (e.g. "Delete tag?") */
    title: string
    /** Loading state for the action button */
    loading?: boolean
    /** Disable the action button */
    disabled?: boolean
    /** Label for the action button */
    actionLabel?: string
    /** Color for the action button */
    actionColor?: "error" | "primary" | "neutral" | "secondary" | "success" | "info" | "warning"
    /** Icon for the action button */
    actionIcon?: string
  }>(),
  {
    actionLabel: "Delete",
    actionColor: "error",
  },
)

const emit = defineEmits<{
  "update:open": [value: boolean]
  confirm: []
}>()
</script>

<template>
  <UModal :open="open" @update:open="emit('update:open', $event)">
    <template #header>{{ title }}</template>
    <template #body>
      <slot />
    </template>
    <template #footer>
      <div class="flex justify-end gap-4">
        <UButton
          label="Cancel"
          color="neutral"
          variant="outline"
          @click="emit('update:open', false)"
        />
        <UButton
          :label="actionLabel"
          :color="actionColor"
          :icon="actionIcon"
          :loading="loading"
          :disabled="disabled"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </UModal>
</template>
